module.exports = __webpack_public_path__ + "img/twitter.74f2ce33.png";